import React from 'react';
import {useDropzone} from 'react-dropzone';
import {Box} from '@mui/material';
import Icon from 'shared/components/icon';
import 'stylesheets/components/educator-account-settings/educator-account-settings-form.scss';
import styles from './styles.module.scss';

const MIME_TYPES: Record<string, string> = {
  csv: 'text/csv',
  xls: 'application/vnd.ms-excel',
  xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  pdf: 'application/pdf',
  png: 'image/png',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
};

interface Props {
  getSelectedFile: (file: File) => void;
  uploading: boolean;
  fileName: string;
  acceptedFileTypes?: string[];
}

export default function FileSelector({
  getSelectedFile,
  uploading,
  fileName,
  acceptedFileTypes,
}: Props) {
  const acceptFile = ([acceptedFile]: File[]) => {
    if (!acceptedFile) {
      return;
    }

    getSelectedFile(acceptedFile);
  };

  const {getRootProps, getInputProps} = useDropzone({
    multiple: false,
    accept: acceptedFileTypes
      ? Object.fromEntries(acceptedFileTypes.map((ext) => [MIME_TYPES[ext.slice(1)], [ext]]))
      : undefined,
    onDrop: acceptFile,
  });

  return (
    <div {...getRootProps()} className={styles.dropzone} data-testid="file-selector-drop-zone">
      <input {...getInputProps()} />
      {fileName ? (
        <>
          <Icon iconType="file-alt" className="download-report-icon" />
          <span data-testid="file-name"> {fileName} </span>
          {uploading && <Icon iconType="spinner" className="rm-spinner rm-spin" />}
        </>
      ) : (
        <Box className={styles.fileSelectorBox} data-testid="add-file">
          <Icon iconType="plus-r" className={styles.addIcon} />
        </Box>
      )}
    </div>
  );
}
